<template>
    <div>
        <CRow class="w-100">
            <CCol md="12" lg="12" sm="12" xs="12">
                <ReportsVue v-if="page == 'home'" @changePage="changePage" @setView="setView" />

                <PurchaseVue class="pt-1" v-if="page == 'purchase_reports'" @mtdBack="mtdBack" />
                <SaleVue class="pt-1" v-if="page == 'sale_reports'" @mtdBack="mtdBack" :bead="caja" />
                <SaleGeneralVue class="pt-1" v-if="page == 'sale_reports_general'" @mtdBack="mtdBack" />
                <PurchaseGeneralVue class="pt-1" v-if="page == 'purchase_reports_general'" @mtdBack="mtdBack" />
                <UtilidadesVue class="pt-1" v-if="page == 'utilidades_reports'" @mtdBack="mtdBack" />

                <ReportBead class="pt-1" v-if="page == 'bead_report' && $store.getters.get_company.id == 1" @mtdBack="mtdBack" />
                <ReportAqBead class="pt-1" v-if="page == 'bead_report' && $store.getters.get_company.id == 3" @mtdBack="mtdBack" />
                <ReportAqWarranty class="pt-1" v-if="page == 'report_warranty' && $store.getters.get_company.id == 3" @mtdBack="mtdBack" />
                <ReportNote class="pt-1" v-if="page == 'report_note'" @mtdBack="mtdBack" />
                <ReportMovementStock class="pt-1" v-if="page == 'report_movement_stock' && $store.getters.get_company.id == 3" @mtdBack="mtdBack" />
                <ReportComandCancel class="pt-1" v-if="page == 'comand_cancel'"  @mtdBack="mtdBack" />
                <ReportMethodPayment class="pt-1" v-if="page == 'report_method'"  @mtdBack="mtdBack" />
            </CCol>
        </CRow>
    </div>
</template>

<script>


import ReportsVue from '../../components/reports/demo/Home.vue';
import ReportsAqVue from '../../components/reports/aq/Home.vue';

import PurchaseVue from '../../components/reports/demo/ReportPurchase.vue';
import SaleVue from '../../components/reports/demo/ReportSale.vue';
import SaleGeneralVue from '../../components/reports/demo/ReportSaleGeneral.vue';
import PurchaseGeneralVue from '../../components/reports/demo/ReportPurchaseGeneral.vue';
import UtilidadesVue from '../../components/reports/demo/ReportUtilidades.vue';
import ReportBead from '../../components/reports/demo/ReportBead.vue';
import ReportAqBead from '../../components/reports/aq/ReportBead.vue';
import ReportAqWarranty from '../../components/reports/aq/ReportWarranty.vue';
import ReportNote from '../../components/reports/demo/ReportExitNote.vue';
import ReportMovementStock from '../../components/reports/aq/ReportMovemtStock.vue';
import ReportComandCancel from '../../components/reports/demo/ReportComandCancel.vue';
import ReportMethodPayment from '../../components/reports/demo/ReportMethodPayment.vue';


export default {
    components: {
        ReportsVue,
        PurchaseVue,
        SaleVue,
        SaleGeneralVue,
        PurchaseGeneralVue,
        UtilidadesVue,
        ReportBead,
        ReportAqBead,
        ReportsAqVue,
        ReportAqWarranty,
        ReportNote,
        ReportMovementStock,
        ReportComandCancel,
        ReportMethodPayment
    },
    data() {
        return {
            page: 'home',
            caja:null
        }
    },
    methods: {
        changePage(page,caja) {
            this.page = page;
            this.caja = caja;
            this.$emit("mtdViewFooter", false, 'home');
        },
        returnHome() {
            this.page = 'home';
            this.$emit("mtdViewFooter", true, 'home');
        },
        hasRoles(roles) {
            return roles.some(role => this.userRoles.includes(role));
        },
        mtdBack: function () {
            this.page = 'home';
            // this.$emit('setView', 'home')
        },
        setView: function () {
            this.$emit('setView', 'home')
        }
    }
};
</script>